import Pagination from "../../Pagination/Pagination"
const HospitalTable = ({ hospitals, onEdit, onAdd, onDelete, totalPages, currentPage, onPageChange }) => {
  console.log("hoxsfghjk", hospitals);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <button
          onClick={onAdd}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Add Hospital
        </button>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Hospital Name
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Phone Number
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Email</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              City
            </th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {hospitals.map((hospital) => {
            return (
              <tr key={hospital._id}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hospital.hospitalName}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hospital.hospitalPhoneNumber}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hospital.hospitalEmail}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {hospital.hospitalCity}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <button
                    onClick={() => onEdit(hospital)}
                    style={{
                      marginRight: "10px",
                      padding: "5px 10px",
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => onDelete(hospital._id)}
                    style={{
                      padding: "5px 10px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />
    </div>
  );
};

export default HospitalTable;
